import React, { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import { apiClient, clearToken, getToken } from "@/lib/api";
import { Loader2 } from "lucide-react";

export default function RequireAdmin({ children }) {
  const [state, setState] = useState({ checking: true, ok: false });

  useEffect(() => {
    let cancelled = false;
    (async () => {
      if (!getToken()) {
        if (!cancelled) setState({ checking: false, ok: false });
        return;
      }
      try {
        await apiClient.get("/auth/me");
        if (!cancelled) setState({ checking: false, ok: true });
      } catch (e) {
        clearToken();
        if (!cancelled) setState({ checking: false, ok: false });
      }
    })();
    return () => {
      cancelled = true;
    };
  }, []);

  if (state.checking) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-white text-zinc-400">
        <Loader2 className="animate-spin text-[#E63946]" size={28} />
      </div>
    );
  }
  if (!state.ok) return <Navigate to="/admin/login" replace />;
  return children;
}
